import { DEFAULT_ID, Loader } from "@googlemaps/js-api-loader";
import axios from "axios";
import datepicker from "js-datepicker";

export function init(apiBase, apiKey) {
  const urlPath = window.location.pathname.split("/");
  const storeId = urlPath[urlPath.length - 1];

  if (document.querySelector("#single-store-map")) {
    let ciSearch = false;
    let errorRedirect = "../try-linn";
    let closedDays = [];

    if (window.location.pathname.includes("whole-home")) {
      ciSearch = true;
      errorRedirect = "../find-an-installer";
    } else {
      const urlParams = new URLSearchParams(window.location.search);
      const preSearchProduct = urlParams.has("pr") ? urlParams.get("pr") : "";
      const preSearchRange = urlParams.has("ra") ? urlParams.get("ra") : "";

      if (document.querySelector("#system")) {
        document.querySelector("#system").value =
          preSearchProduct + "|" + preSearchRange;
      }
    }

    const selectText = document
      .querySelector(".module-storeinfo")
      .getAttribute("data-selecttext");

    document.querySelector(".overlay").classList.add("-white");
    document.querySelector(".overlay").classList.add("-visible");

    // Set up Map ----------------------- //
    let map;

    const loader = new Loader({
      apiKey: apiKey,
      version: "weekly",
    });

    loader.load().then(() => {
      const userlat = parseFloat(
        document.querySelector(".geo-information .latitude").innerText
      );
      const userlng = parseFloat(
        document.querySelector(".geo-information .longitude").innerText
      );

      map = new google.maps.Map(document.getElementById("single-store-map"), {
        center: { lat: userlat, lng: userlng },
        zoom: 12,
      });
    });
    // End Set up Map ---------------------- //

    // Get store data from API and populate DOM ------------ //

    axios({
      method: "get",
      url: apiBase + "retailers/" + storeId + "/full",
    })
      .then(function (response) {
        if (response.data === "") {
          // no match
          window.location = errorRedirect;
        } else {
          document.querySelector(".overlay").classList.remove("-visible");
          document.querySelector(".overlay").classList.remove("-white");

          const latlong = {
            lat: parseFloat(response.data.geocode.latitude),
            lng: parseFloat(response.data.geocode.longitude),
          };

          setTimeout(() => {
            const marker = new google.maps.Marker({
              position: latlong,
              map: map,
              icon:
                "https://" +
                window.location.hostname +
                "/assets/dist/img/icon-map-pin.svg",
            });
            map.setCenter(latlong);
          }, 500);

          document.title = response.data.name + " | " + document.title;
          document.querySelector(".demo-booking .retailer-id").value =
            response.data.id;

          // Title area
          document.querySelector(".module-storeinfo .title").innerText =
            response.data.name;
          if (response.data.webDescription)
            document.querySelector(".module-storeinfo .intro").innerHTML =
              response.data.webDescription;

          // Address
          document.querySelector(
            ".module-storeinfo .address .content"
          ).innerHTML = `<strong>${response.data.name}</strong>`;
          document.querySelector(
            ".module-storeinfo .address .content"
          ).innerHTML += `<br>${response.data.address.line1}`;
          if (response.data.address.line2)
            document.querySelector(
              ".module-storeinfo .address .content"
            ).innerHTML += `<br>${response.data.address.line2}`;
          if (response.data.address.line3)
            document.querySelector(
              ".module-storeinfo .address .content"
            ).innerHTML += `<br>${response.data.address.line3}`;
          if (response.data.address.line4)
            document.querySelector(
              ".module-storeinfo .address .content"
            ).innerHTML += `<br>${response.data.address.line4}`;
          if (response.data.address.postcode)
            document.querySelector(
              ".module-storeinfo .address .content"
            ).innerHTML += `<br>${response.data.address.postcode}`;

          // Contact details
          let phoneNumber = "-";
          if (response.data.phoneNumber)
            phoneNumber = `<a href="tel:${response.data.phoneNumber}" target="_blank">${response.data.phoneNumber}</a>`;

          let emailAddress = "-";
          if (response.data.emailAddress)
            emailAddress = `<a href="mailto:${response.data.emailAddress}" target="_blank">${response.data.emailAddress}</a>`;

          let websiteUrl = "-";
          if (response.data.websiteUrl) {
            if (response.data.websiteUrl.slice(0, 4) === "http") {
              websiteUrl = `<a href="${response.data.websiteUrl}" target="_blank">${response.data.websiteUrl}</a>`;
            } else {
              websiteUrl = `<a href="http://${response.data.websiteUrl}" target="_blank">${response.data.websiteUrl}</a>`;
            }
          }

          document.querySelector(".module-storeinfo .tel .content").innerHTML =
            phoneNumber;
          document.querySelector(
            ".module-storeinfo .email .content"
          ).innerHTML = emailAddress;
          document.querySelector(
            ".module-storeinfo .website .content"
          ).innerHTML = websiteUrl;

          // Opening Hours
          let openingHoursHtml = "";
          response.data.openingHours.forEach(function (day, i) {
            if (day.status === "Open") {
              const dayHours = day.summary.join(", ");
              if (dayHours !== "") {
                openingHoursHtml += `<div>${toTranslatedString(
                  day.day
                )} : ${dayHours}</div>`;
              } else {
                openingHoursHtml += `<div>${toTranslatedString(
                  day.day
                )}: ${toTranslatedString(day.status)}</div>`;
              }
            } else {
              openingHoursHtml += `<div>${toTranslatedString(
                day.day
              )}: ${toTranslatedString(day.status)}</div>`;
              let dayToAdd = i + 1;
              if (i + 1 === 7) {
                dayToAdd = 0;
              }
              closedDays.push(dayToAdd);
            }
          });

          if (openingHoursHtml === "") {
            document.querySelector(
              ".shop-details .col:nth-child(2)"
            ).innerHTML = "";
          } else {
            document.querySelector(
              ".module-storeinfo .opening-times"
            ).innerHTML = openingHoursHtml;
          }

          // Images
          let thumbnailMarkup = "";
          response.data.links.forEach((link) => {
            if (link.rel === "retailer-page") {
              thumbnailMarkup = `<img src="${link.href}">`;
            }
          });

          if (thumbnailMarkup === "") {
            document.querySelector(".module-storeinfo .store-image").remove();
          } else {
            document.querySelector(".module-storeinfo .store-image").innerHTML =
              thumbnailMarkup;
          }

          // Products

          if (
            response.data.products.networkMusicPlayers.length ||
            response.data.products.speakers.length ||
            response.data.products.turntables.length
          ) {
            // console.log(response.data);

            const textSystemsAvailable = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-systemsavailable");
            const textAlsoAvailable = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-alsoavailable");
            const textDSMs = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-networkmusicplayers");
            const textTurntables = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-turntables");
            const textSpeakers = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-speakers");
            const textAmps = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-amps");
            const textSurroundSound = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-surroundsound");
            const textWholeHome = document
              .querySelector(".module-storeinfo")
              .getAttribute("data-wholehome");

            let productMarkup = `<h4>${textSystemsAvailable}</h4><div class="products">`;

            const allThumbnails = document.querySelectorAll(
              ".product-thumbnails div"
            );

            if (response.data.products.networkMusicPlayers.length) {
              let topProduct = response.data.products.networkMusicPlayers[0];
              let productThumbnail = "";
              allThumbnails.forEach(function (el) {
                if (
                  el
                    .getAttribute("data-apistring")
                    .includes("networkmusicplayers") &&
                  el.getAttribute("data-apistring").includes(topProduct)
                ) {
                  productThumbnail = el.getAttribute("data-url");
                }
              });
              productMarkup += `<div class="product-cat"><div class="image"><img src="${productThumbnail}"></div><div class="content"><h4>${textDSMs}</h4><ul>`;
              response.data.products.networkMusicPlayers.forEach(function (
                prod
              ) {
                productMarkup += `<li>${toTitleCase(prod)}</li>`;
              });
              productMarkup += "</ul></div></div>";
            }

            if (response.data.products.speakers.length) {
              let topProduct = response.data.products.speakers[0];
              let productThumbnail = "";
              allThumbnails.forEach(function (el) {
                if (
                  el.getAttribute("data-apistring").includes("speakers") &&
                  el.getAttribute("data-apistring").includes(topProduct)
                ) {
                  productThumbnail = el.getAttribute("data-url");
                }
              });
              productMarkup += `<div class="product-cat"><div class="image"><img src="${productThumbnail}"></div><div class="content"><h4>${textSpeakers}</h4><ul>`;
              response.data.products.speakers.forEach(function (prod) {
                if (prod === "series5") {
                  prod = "Series 5";
                }
                if (prod === "klimax") {
                  prod = "360";
                }
                productMarkup += `<li>${toTitleCase(prod)}</li>`;
              });
              productMarkup += "</ul></div></div>";
            }

            if (response.data.products.turntables.length) {
              let topProduct = response.data.products.turntables[0];
              let productThumbnail = "";
              allThumbnails.forEach(function (el) {
                if (
                  el.getAttribute("data-apistring").includes("turntables") &&
                  el.getAttribute("data-apistring").includes(topProduct)
                ) {
                  productThumbnail = el.getAttribute("data-url");
                }
              });
              productMarkup += `<div class="product-cat"><div class="image"><img src="${productThumbnail}"></div><div class="content"><h4>${textTurntables}</h4><ul>`;
              response.data.products.turntables.forEach(function (prod) {
                //take below out once retailers backend altered to stop returning akurate
                if (prod !== "akurate") {
                  productMarkup += `<li>${toTitleCase(prod)}</li>`;
                }
              });
              productMarkup += "</ul></div></div>";
            }

            if (response.data.products.amps.length) {
              let topProduct = response.data.products.amps[0];
              let productThumbnail = "";
              allThumbnails.forEach(function (el) {
                if (
                  el.getAttribute("data-apistring").includes("amps") &&
                  el.getAttribute("data-apistring").includes(topProduct)
                ) {
                  productThumbnail = el.getAttribute("data-url");
                }
              });
              productMarkup += `<div class="product-cat"><div class="image"><img src="${productThumbnail}"></div><div class="content"><h4>${textAmps}</h4><ul>`;
              response.data.products.amps.forEach(function (prod) {
                if (prod === "solo800") {
                  prod = "Klimax Solo 800";
                }
                productMarkup += `<li>${toTitleCase(prod)}</li>`;
              });
              productMarkup += "</ul></div></div>";
            }

            productMarkup += "</div></div>";

            if (
              response.data.products.surroundSystems ||
              response.data.wholeHomeProfessional
            ) {
              productMarkup += `<h4>${textAlsoAvailable}</h4><div class="also"><ul>`;
            }

            if (response.data.products.surroundSystems) {
              productMarkup += `<li>${textSurroundSound}</li>`;
            }

            if (response.data.wholeHomeProfessional) {
              productMarkup += `<li>${textWholeHome}</li>`;
            }

            if (
              response.data.products.surroundSystems ||
              response.data.wholeHomeProfessional
            ) {
              productMarkup += "</div></ul>";
            }

            document.querySelector(".module-storeinfo .systems").innerHTML =
              productMarkup;
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        window.location = errorRedirect;
      });

    if (
      !document.querySelector("form.demo-booking").classList.contains("-custom")
    ) {
      const d = new Date();
      const dateField = document.querySelector(
        '.demo-booking input[name="date"]'
      );
      const timeField = document.querySelector(
        '.demo-booking select[name="time"]'
      );

      axios({
        method: "get",
        url: apiBase + "retailers/" + storeId + "/timeslots",
        params: {
          month: d.getMonth() + 1,
          year: d.getFullYear(),
        },
      })
        .then(function (response) {
          setTimeout(() => {
            const picker = datepicker(dateField, {
              disableYearOverlay: true,
              minDate: new Date(d.setDate(d.getDate() + 1)),
              maxDate: new Date(d.setMonth(d.getMonth() + 6)),
              disabler: (date) => {
                for (let x = 0; x < closedDays.length; x++) {
                  if (date.getDay() === closedDays[x]) {
                    return true;
                  }
                }
              },
              onSelect: (instance, date) => {
                axios({
                  method: "get",
                  url: apiBase + "retailers/" + storeId + "/timeslots",
                  params: {
                    dateTime: date,
                  },
                })
                  .then(function (response) {
                    let timeOptions = `<option value="">${selectText}</option>`;
                    response.data[0].timeSlots.forEach(function (timeslot) {
                      if (timeslot.available === true) {
                        const timeparts = timeslot.startTime.split(":");
                        const datetime = date.setHours(
                          timeparts[0],
                          timeparts[1],
                          0,
                          0
                        );
                        timeOptions += `<option value="${new Date(datetime)}">${
                          timeslot.startTime
                        } - ${timeslot.endTime}</option>`;
                      }
                    });

                    timeField.innerHTML = timeOptions;
                    timeField.disabled = false;
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              },
            });
          }, 500);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    // End get store data from API ---------------- //

    // Handle submission of booking form ------------------- //
    const demoForm = document.querySelector("form.demo-booking");
    demoForm.addEventListener("submit", function (e) {
      e.preventDefault();

      if (document.querySelector('.demo-booking .g-recaptcha-response').value !== "") {
        document.querySelector(".recaptcha-validation-text").style.visibility =
          "hidden";

        document.querySelector(".overlay").classList.add("-white");
        document.querySelector(".overlay").classList.add("-visible");

        const urlParams = new URLSearchParams(window.location.search);
        const searchTerm = urlParams.has("s") ? urlParams.get("s") : "";

        const formData = new FormData();

        let apiEndpoint;

        if (demoForm.classList.contains("-custom")) {
          // custom installer

          apiEndpoint = "demo-booking/consultations";

          const days = demoForm.querySelectorAll(".checkbox-list.-days input");
          const selectedDays = [];

          days.forEach((day) => {
            if (day.checked === true) {
              selectedDays.push(day.value);
            }
          });

          const times = demoForm.querySelectorAll(
            ".checkbox-list.-times input"
          );
          const selectedTimes = [];

          times.forEach((time) => {
            if (time.checked === true) {
              selectedTimes.push(time.value);
            }
          });

          formData.append(
            "country",
            demoForm.querySelector('select[name="country"]').value
          );

          formData.append("consultationDays", selectedDays);
          formData.append("consultationTime", selectedTimes);
          fbq("trackCustom", "BookAConsultation", { storeId: storeId });
        } else {
          // retailer demo booking

          apiEndpoint = "demo-booking/demo-requests";
          const emailAddress = demoForm.querySelector(
            'input[name="emailAddress"]'
          ).value;

          formData.append(
            "system",
            demoForm.querySelector('select[name="system"]').value
          );
          formData.append(
            "aboutMe",
            demoForm.querySelector('select[name="about"]').value
          );
          formData.append("emailAddress", emailAddress);
          formData.append(
            "emailSubscribe",
            !demoForm.querySelector('input[name="emailSubscribe"]').checked
          );
          formData.append(
            "language",
            document
              .querySelector(".module-storeinfo")
              .getAttribute("data-language")
          );

          fbq("trackCustom", "BookADemo", {
            storeId: storeId,
            emailAddress: emailAddress,
          });

          gtag("event", "BookADemo", {
            event_category: "Forms",
            event_action: "Submit",
            event_label: "BookADemo",
          });
        }

        formData.append(
          "name",
          demoForm.querySelector('input[name="name"]').value
        );
        formData.append(
          "venueUri",
          "retailers/" +
            demoForm.querySelector('input[name="retailerId"]').value
        );
        formData.append(
          "notes",
          demoForm.querySelector('textarea[name="notes"]').value
        );
        formData.append(
          "phoneNumber",
          demoForm.querySelector('input[name="phoneNumber"]').value
        );

        formData.append("locationSearchTerm", searchTerm);

        formData.append(
          "g-recaptcha-response",
          document.querySelector('.demo-booking .g-recaptcha-response').value
        );

        axios({
          method: "post",
          url: apiBase + apiEndpoint,
          data: formData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        })
          .then(function (response) {
            //success
            document.querySelector(".overlay").classList.remove("-white");
            document.querySelector(".overlay").classList.remove("-visible");
            demoForm.remove();
            document.querySelector("p.intro").classList.add("-hidden");
            document.querySelector("p.thanks").classList.remove("-hidden");
            document
              .querySelector(".module-bookdemo .contents")
              .scrollIntoView();
          })
          .catch(function (response) {
            console.log(response);
          });
      } else {
        document.querySelector(".recaptcha-validation-text").style.visibility =
          "visible";
      }
    });

    // End handle submission of booking form --------------- //
    document.getElementById("email-div").addEventListener("click", () => {
      gtag("event", "click-retailer-email", {
        event_category: "click",
        event_label: "click-retailer-email",
        value: storeId,
      });
    });
    document.getElementById("tel-div").addEventListener("click", () => {
      gtag("event", "click-retailer-tel", {
        event_category: "click",
        event_label: "click-retailer-tel",
        value: storeId,
      });
    });
  }
}

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function toTranslatedString(str) {
  const lowerCaseString = str.replace(/\s/g, "").toLowerCase();
  const translatedString = document
    .querySelector("#opening-times")
    .getAttribute(`data-${lowerCaseString}`);
  if (translatedString === null) {
    return "";
  }
  return translatedString;
}
